var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Context',{ref:"context",attrs:{"overflow-scroll":"","max-height-if-outside-viewport":""}},[_c('ViewDecoratorList',{attrs:{"database":_vm.database,"view":_vm.view},on:{"select":function($event){return _vm.$emit('select', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }